"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Login/MFA/PhoneForm.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reacthookform = require('react-hook-form');
var _useFieldErrorDisplay = require('shared/hooks/useFieldErrorDisplay'); var _useFieldErrorDisplay2 = _interopRequireDefault(_useFieldErrorDisplay);

var _smsNotice = require('shared/constants/smsNotice');

var _contact = require('shared/validation/user/contact');
var _Form = require('web/components/Form');
var _mfaErrors = require('shared/constants/mfaErrors');







const PhoneForm = ({
  onSubmit,
  phonePolicy = 'strict',
  intro = 'Add a mobile phone number that can receive SMS verification codes.',
}) => {
  const resolver = _react.useMemo.call(void 0, () => _contact.getMFAPhoneResolver.call(void 0, phonePolicy), [phonePolicy])
  const { control, handleSubmit, setError, formState } =
    _reacthookform.useForm({
      // Validate a field when it loses focus, then as it is edited to clear the
      // error: never while its first value is still being typed.
      mode: 'onTouched',
      resolver,
      defaultValues: { phone: '' },
    })
  const { isDirty, isValid, isSubmitting } = formState
  // Shown once they leave the field after typing (or send), never while they type.
  const display = _useFieldErrorDisplay2.default.call(void 0, { phone: formState.errors.phone })
  const phoneError = display.shown('phone')

  const submit = data =>
    onSubmit(data.phone)
      .catch(e => setError('phone', { message: _mfaErrors.mfaErrorMessage.call(void 0, e) }))

  return (
    _react2.default.createElement('form', { onSubmit: handleSubmit(submit, errs => display.onSubmitErrors(Object.keys(errs))), __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}}
      , _react2.default.createElement('p', { className: "auth-body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}},  intro )
      , _react2.default.createElement(_Form.InputSectionWrapper, { title: "Mobile phone" , errorMessage: _optionalChain([phoneError, 'optionalAccess', _ => _.message]), __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}}
        , _react2.default.createElement(_Form.PhoneInputController, {
          autoFocus: true,
          control: control,
          name: "phone",
          hasError: !!phoneError,
          onType: () => display.onType('phone'),
          onLeave: value => display.onLeave('phone', value),
          phonePolicy: phonePolicy, __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}
        )
      )
      , _react2.default.createElement('p', { className: "auth-small", __self: this, __source: {fileName: _jsxFileName, lineNumber: 54}}, _smsNotice.SMS_TRANSACTIONAL_PHONE_NOTICE)
      , _react2.default.createElement(_Form.Button, { isSubmit: true, isDisabled: !isDirty || !isValid || isSubmitting, isLoading: isSubmitting, __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}}
        ,  isSubmitting ? 'Sending code…' : 'Send code' 
      )
    )
  )
}

exports. default = PhoneForm
